<template>
    <div class="content_box mobile_content">
        <div class="content">
            <div class="title_box">
                <div class="title">
                    <span>产测账号设置</span>
                </div>
            </div>
            <div class="btn_box">
                <div class="button button2 add" @click="addDislogShow" v-if="roleCheck('106-101-101-102')">
                    <i class="el-icon-plus"></i>
                    <span>新建</span>
                </div>
            </div>
            <el-table
                highlight-current-row
                :data="listData"
                style="width: 100%">
                
                <el-table-column prop="remark" label="备注"></el-table-column>
                <el-table-column prop="password" label="账号" width="220"></el-table-column>
                <el-table-column prop="pcba" label="PCBA版本"></el-table-column>
                <el-table-column prop="machine" label="整机版本"></el-table-column>
                <el-table-column prop="create_time" label="创建日期"></el-table-column>
                <el-table-column prop="permission" label="权限"></el-table-column>
                <el-table-column label="操作" width="100">
                    <template slot-scope="scope" >
                        <div>
                            <div class="button text" @click="updateDislogShow(scope.row)" v-if="roleCheck('106-101-101-102')">编辑</div>
                        </div>
                    </template>
                </el-table-column>
            </el-table>
            <Gh-Dialog ref="ptAccountSetting" size="big" :title="dialog.title" @dialogBack="settingConfirm">
                <template v-slot:content>
                    <el-form label-width="100px" :model="actData" ref="addProductRule">
                        <el-form-item label="账号" prop="pwd">
                            <el-input v-model="actData.pwd" placeholder="请输入账号"></el-input>
                        </el-form-item>
                        <el-form-item label="PCBA版本" prop="pcba">
                            <el-input v-model="actData.pcba" placeholder=""></el-input>
                        </el-form-item>
                        <el-form-item label="整机版本" prop="machine">
                            <el-input v-model="actData.machine" placeholder=""></el-input>
                        </el-form-item>
                        <el-form-item label="权限" prop="permission">
                            <el-checkbox-group v-model="permission">
                                <el-checkbox label="1">猫砂盆产测</el-checkbox>
                                <el-checkbox label="4">猫砂盆维修</el-checkbox>
                                <el-checkbox label="3">猫砂盆代理商产测</el-checkbox>
                                <el-checkbox label="2">S1产测</el-checkbox>
                                <el-checkbox label="9">称重系统</el-checkbox>
                            </el-checkbox-group>
                        </el-form-item>
                        <el-form-item label="备注" prop="remark">
                            <el-input type="textarea" v-model="actData.remark" placeholder=""></el-input>
                        </el-form-item>
                    </el-form>
                </template>
            </Gh-Dialog>
        </div>
    </div>
</template>
<script>
export default({
    name: 'pt-account-setting',
    data() {
        return {
            searchData: {
                page: 1,
                page_size: 10
            },
            permission: [],
            dialog: {},
            actData: {},
            accountData: [],
            listData: []
        }
    },
    watch: {
       
    },
    created() {
        this.getList();
    },
    methods: {
        getList() {
            this.api.ptAccountList({}).then(data => {
                this.accountData = data.data;
                const defaultArr = this.accountData.filter(item => item.password == 'genhigh_default');
                const filterArr = this.accountData.filter(item => item.password != 'genhigh_default');
                const sortArr = filterArr.sort((a,b) => {
                    return a.permission.split(',')[0] - b.permission.split(',')[0];
                })
                this.listData = [...defaultArr, ...sortArr];
            })
        },
        addDislogShow() {
            this.dialog = {
                title: '新增账号',
                type: 'add'
            };
            this.actData = {
                pwd: '',
                permission: []
            };
            this.permission = [];
            this.$refs.ptAccountSetting.show = true;
        },
        updateDislogShow(item) {
            this.dialog = {
                title: '修改账号',
                type: 'update'
            };
            this.actData = {
                id: item.Id,
                pwd: item.password,
                permission: item.permission.split(','),
                machine: item.machine,
                pcba: item.pcba,
                remark: item.remark
            };
            this.permission = item.permission.split(',');
            this.$refs.ptAccountSetting.show = true;
        },
        settingConfirm() {
            this.actData.permission = this.permission.join(',');
            if(this.dialog.type == 'add') {
                this.api.ptAccount(this.actData).then(data => {
                    this.actData = {};
                    this.$refs.ptAccountSetting.show = false;
                    this.getList();
                })
            }else{
                this.api.ptAccountUpdate(this.actData).then(data => {
                    this.actData = {};
                    this.$refs.ptAccountSetting.show = false;
                    this.getList();
                })
            }
            
        }
    }
})
</script>
<style lang="less" scoped>
    
</style>



// WEBPACK FOOTER //
// src/view/product-test-tool/account/setting.vue